import sanitizeHtml from 'sanitize-html';

// What the embed editor writes, lower-cased as the parser reports them. The web component
// copies these onto a live <iframe>: srcdoc would run same-origin HTML, and name would
// shadow window globals.
const IFRAME_EMBED_ATTRIBUTES = [
  'src',
  'frameborder',
  'allow',
  'allowfullscreen',
  'referrerpolicy',
  'loading',
  'sandbox',
  'seamless',
  'scrolling',
  'height',
  'width',
  'style',
  'metaposition',
  'metatype',
];

/** Sanitises venue-authored rich text, keeping embeds but only the attributes the editor writes. */
export const sanitizeRichText = (html: string): string => sanitizeHtml(html, {
  allowedTags: sanitizeHtml.defaults.allowedTags.concat(['iframe-embed', 'img']),
  allowedAttributes: {
    ...sanitizeHtml.defaults.allowedAttributes,
    'iframe-embed': IFRAME_EMBED_ATTRIBUTES,
  },
});
